__turbopack_context__.v({
  "disabled": "_0iiXvG_disabled",
  "groupLabel": "_0iiXvG_groupLabel",
  "legend": "_0iiXvG_legend",
  "required": "_0iiXvG_required",
});
